var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{directives:[{name:"resize",rawName:"v-resize",value:(_setup.resizeMap),expression:"resizeMap"}],staticClass:"map-container",attrs:{"fill-height":""}},[_c(_setup.MapControl,{attrs:{"uiid":_setup.map_uiid}}),_c(_setup.FleetMap,{ref:"map",attrs:{"uiid":_setup.map_uiid}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }